import Marquee from "react-fast-marquee";
import { Zap } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const BrandMarquee = () => {
    const { t } = useLang();
    const items = t("marquee");

    return (
        <div data-testid="brand-marquee" className="relative w-[104%] -ml-[2%] -rotate-1 border-y border-volt/60 bg-volt py-3.5 shadow-[0_0_60px_rgba(212,255,0,0.25)]">
            <Marquee speed={32} gradient={false} direction="left">
                {items.map((item, i) => (
                    <span
                        key={i}
                        className="mx-6 inline-flex items-center gap-6 font-display text-lg sm:text-2xl font-black uppercase tracking-wide text-obsidian"
                    >
                        {item}
                        <Zap className="h-5 w-5" fill="#08090C" strokeWidth={0} />
                    </span>
                ))}
            </Marquee>
        </div>
    );
};

export default BrandMarquee;
